<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      width="50%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="flex" style="justify-content: center">
        <avue-crud :data="tableData" :option="option">
          <template #header>
            <div class="flex align-items marginBottom10 fontSize">
              <div class="fontSize">总题数：{{ infoData.totalNum }}题</div>
              <div class="marginLeft20 fontSize">
                答对题数：{{ infoData.rightNum }}题
              </div>
              <div class="marginLeft20 fontSize">
                答错题数：{{
                  Number(infoData.totalNum) - Number(infoData.rightNum)
                }}题
              </div>
              <div class="marginLeft20 fontSize">
                得分：{{ infoData.score }}分
              </div>
            </div>
          </template>

          <template slot="type" slot-scope="{ row }">
            <div>{{ MQuestionType[row.type] || "" }}</div>
          </template>
          <template slot="answer" slot-scope="{ row }">
            <div>{{ row.answer || "未作答" }}</div>
          </template>
          <template slot="state" slot-scope="{ row }">
            <div>{{ answerResult[row.state] || "" }}</div>
          </template>
        </avue-crud>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from "element-ui";
import { questionResultsList } from "@/api/question/record";
import { MQuestionType } from "@/enums/beCurrent/EBeCurrent";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import { mobilePhoneRule } from "@/utils/formRules";
import dayjs from "dayjs";

import questionList from "../components/questionList.vue";
export default {
  name: "index",
  components: {
    questionList,
  },
  props: {},
  data() {
    return {
      MQuestionType,
      dialogVisible: false, // 弹窗的是否展示
      dialogTitle: "", // 弹窗的标题
      formLoading: false, // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
      formType: "", // 表单的类型：create - 新增；update - 修改
      formData: {
        name: "",
        questionIds: [],
        multiScore: "",
        examTime: "",
        passScore: "",
        singleScore: "",
        totalScore: "",
      },
      option: {
        maxHeight: 600,
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menu: false,
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,

        selectionFixed: true,
        column: [
          {
            label: "题目",
            prop: "title",
          },
          {
            label: "题目类型",
            prop: "type",
          },
          {
            label: "分值",
            prop: "score",
          },
          {
            label: "用户提交",
            prop: "answer",
          },
          {
            label: "正确答案",
            prop: "realAnswer",
          },
          {
            label: "结果",
            prop: "state",
          },
        ],
      },
      // 表格搜索条件
      searchData: {
        code: "",
        title: "",
        type: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      questionsShow: false,
      tableData: [],
      showLoading: false,
      infoData: {},
      //答题结果：1-答对；2-答错；3-未答
      answerResult: {
        1: "答对",
        2: "答错",
        3: "未答",
      },
    };
  },
  created() {},
  methods: {
    /**
     * 打开答题情况弹窗
     * @param {string|number} id - 记录ID
     * @returns {Promise<void>}
     */
    async open(id) {
      this.dialogVisible = true;
      this.dialogTitle = "答题情况";

      this.resetForm();
      this.onLoad(id);
    },

    /**
     * 重置表单数据
     * @returns {void}
     */
    resetForm() {
      this.formData = {
        name: "",
        questionIds: [],
        multiScore: "",
        examTime: "",
        passScore: "",
        singleScore: "",
        totalScore: "",
      };
    },

    /**
     * 关闭弹窗
     * @returns {void}
     */
    handleClose() {
      this.dialogVisible = false;
    },

    /**
     * 加载试题答题结果列表数据
     * @param {string|number} id - 记录ID
     * @returns {void}
     */
    onLoad(id) {
      this.showLoading = true;
      questionResultsList({ id }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.infoData = res.data;
          this.tableData = res.data.results;
          this.page.total = res.data.total;
        }
      });
    },
  },
};
</script>
<style scoped>
.video_box {
  margin-left: 3%;
  margin-bottom: 10px;
}
.video_icon {
  cursor: pointer;
  margin-top: 0.5%;
  margin-left: 10px;
}
.video_span {
  width: 80px;
  margin-left: 10px;
}
.details_box {
  margin-right: 10%;
  max-width: 100%;
  overflow: hidden;
}
.details_box p img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
:deep(.el-input__inner) {
  text-align: left;
}
.tip {
  margin-left: 13%;
  font-weight: bold;
  margin-bottom: 10px;
}
/deep/.v-modal {
  z-index: 0 !important;
}
.fontSize {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin-right: 20px;
}
</style>
